import { h } from "./../../utils/createElement";
import { __assign, __extends, __rest } from "tslib";
import * as React from 'react';
import { emptyFn } from '../../utils/helper';
import { consumeTheme } from '../../utils/theme';
var Checkbox = (function (_super) {
    __extends(Checkbox, _super);
    function Checkbox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            checked: Boolean(_this.props.defaultChecked)
        };
        _this.handleChange = function (e) {
            var props = _this.props;
            if (props.disabled) {
                return;
            }
            if (!('checked' in props)) {
                _this.setState({
                    checked: e.target.checked
                });
            }
            props.onChange(e.target.checked, {
                target: __assign(__assign({}, props), { checked: e.target.checked }),
                stopPropagation: e.stopPropagation.bind(e),
                preventDefault: e.preventDefault.bind(e),
                nativeEvent: e.nativeEvent
            });
        };
        _this.themedRender = function (classNames) {
            var _a, _b;
            var _c = _this.props, prefixCls = _c.prefixCls, className = _c.className, style = _c.style, children = _c.children, disabled = _c.disabled, iconClassName = _c.iconClassName, iconStyle = _c.iconStyle, labelClassName = _c.labelClassName, labelStyle = _c.labelStyle, hollow = _c.hollow, labelClickable = _c.labelClickable, shape = _c.shape, fillType = _c.fillType, rest = __rest(_c, ["prefixCls", "className", "style", "children", "disabled", "iconClassName", "iconStyle", "labelClassName", "labelStyle", "hollow", "labelClickable", "shape", "fillType"]);
            var checked = 'checked' in _this.props ? _this.props.checked : _this.state.checked;
            var classes = classNames(prefixCls, className, prefixCls + "-" + (hollow ? 'hollow' : 'normal'), prefixCls + "-" + fillType, (_a = {},
                _a[prefixCls + "-checked"] = checked,
                _a[prefixCls + "-disabled"] = disabled,
                _a));
            var inputClasses = classNames(prefixCls + "-input", (_b = {},
                _b[prefixCls + "-input-full"] = labelClickable,
                _b));
            var iconClasses = classNames(prefixCls + "-icon", prefixCls + "-icon-" + shape, iconClassName);
            var labelClasses = classNames(prefixCls + "-label", labelClassName);
            return (h("div", { className: classes, style: style },
                h("input", __assign({}, rest, { type: "checkbox", className: inputClasses, onChange: _this.handleChange, disabled: disabled })),
                h("span", { className: iconClasses, style: iconStyle }),
                h("div", { className: labelClasses, style: labelStyle }, children)));
        };
        return _this;
    }
    Checkbox.prototype.render = function () {
        return consumeTheme(this.themedRender);
    };
    return Checkbox;
}(React.Component));
export default Checkbox;
Checkbox.defaultProps = {
    prefixCls: 'dui-m-checkbox',
    onChange: emptyFn,
    disabled: false,
    hollow: false,
    labelClickable: true,
    shape: 'square',
    fillType: 'tick',
};
